import PropTypes from 'prop-types';
import React from 'react';
import QuestionWrapper from '../response/QuestionWrapper';
import Total from './Total';
import Input from './Input';
import NoneCheckbox from './NoneCheckbox';
import * as Matrix from '../matrix/Matrix';
import { tcap } from '../../../utils/translate';

const ConstantSumQuestion = props => {
  const { add_none, id, name, none_text, required, rows, sum } = props;
  return (
    <QuestionWrapper {...props}>
      <Matrix.Table>
        <Matrix.Body>
          {rows.map((row, rowIndex) => (
            <Matrix.Row
              id={row.id}
              key={rowIndex}
              other={row.other}
              questionId={id}
              questionName={name}
              text={row.text}
            >
              <td key={row.name} className="ph2">
                <Input
                  className="mb2"
                  min={0}
                  max={sum}
                  name={`questions[${name}-${row.name}][]`}
                  questionId={id}
                  required={required && !row.other}
                  style={{ minWidth: '5em' }}
                  type="number"
                  rowIndex={rowIndex}
                />
              </td>
            </Matrix.Row>
          ))}
        </Matrix.Body>
        <Matrix.Footer>
          {add_none ? (
            <tr className="constant-sum__none-row">
              <th />
              <th className="constant-sum__none-td">
                <label>
                  <NoneCheckbox
                    name={`questions[${name}-none][]`}
                    questionId={id}
                  />{' '}
                  {none_text}
                </label>
              </th>
            </tr>
          ) : null}
          <tr className="constant-sum__row">
            <th className="constant-sum__target fw-n fs-12">{tcap('total')}</th>
            <Total questionId={id} sum={sum} />
          </tr>
        </Matrix.Footer>
      </Matrix.Table>
    </QuestionWrapper>
  );
};

ConstantSumQuestion.propTypes = {
  add_none: PropTypes.bool,
  add_other: PropTypes.bool,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  none_text: PropTypes.string,
  required: PropTypes.bool,
  rows: PropTypes.array,
  sum: PropTypes.number.isRequired,
  text: PropTypes.string,
};

ConstantSumQuestion.defaultProps = {
  rows: [],
  sum: 100,
};

export default ConstantSumQuestion;
